import { useBreakpoint, Breakpoints, GenericLink, NextgenImage, LoaderType } from '@nextgen-web-framework/all';
import { useState } from 'react';
import { Logger } from '@nextgen-web-framework/core';
import { NavigationCategory } from '../navigationItem/types/protoTypes';
import SkeletonLoader from '../SkeletonLoader/SkeletonLoader';
import styles from './ShopByBrands.module.scss';
import { ShopByBrandsProps } from './types/propsType';

const ShopByBrands = (props: ShopByBrandsProps) => {
  const viewport = useBreakpoint();
  const isMobile = [Breakpoints.SM, Breakpoints.XS].includes(viewport as Breakpoints);
  const [loading, setLoading] = useState<boolean>(true);
  const logger = Logger.getInstance({ component: 'ShopByBrands.tsx', product: 'commerce-webcomponent' });
  const imageLoading: Array<number> = [];
  const setImgLoading = (index: number) => {
    try {
      imageLoading.push(index);
      if (props.categories.length === imageLoading.length) {
        setLoading(false);
      }
    } catch (error) {
      logger.log('Error while loading Images setImageLoading ', error);
    }
  };

  const getImageUrl = (item: NavigationCategory) => {
    const image = item?.imageList?.find((item) => item.viewport.includes(viewport));
    return image?.url || '';
  };

  return (
    <>
      {isMobile && <div className={styles['shopby-header-menu']}>{props.allTitle}</div>}
      <div
        id="shopby-brands-storybook-id"
        className={styles['shopbybrand-image-container']}
        data-testid="shopbybrand-image-container-id"
      >
        {props.categories.map((item: NavigationCategory, index) => (
          <GenericLink
            href={item?.link?.url ?? ''}
            key={`${item.title}-${index.toString()}`}
            className={styles['brand-image-link']}
            target={item?.link?.target}
          >
            <div className={styles['brand-image-container']}>
              <NextgenImage
                className={`lazy-image-shop-by-brand ${styles['brand-image']}`}
                src={getImageUrl(item)}
                alt={item.altText}
                loaderType={LoaderType.CONTENTSTACK}
                onError={(event) => logger.log('Error while loading Images ShopByBrand- ', event)}
                style={!isMobile && loading ? { visibility: 'hidden' } : {}}
                onLoad={() => !isMobile && setImgLoading(index)}
              />
              {!isMobile && loading && <SkeletonLoader height={120} borderRadius={12} />}
            </div>
          </GenericLink>
        ))}
      </div>
    </>
  );
};
export default ShopByBrands;
